export enum DiscountsRoutePathNames {
  DISCOUNTS = 'discounts',
  LIST = '',
  CREATE = 'create',
  UPDATE = ':id',
  RYST_INCENTIVES_MANAGER = 'ryst-incentives-manager',
}
